module.exports = __webpack_public_path__ + "static/img/02st.4703ffa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/06/02st.jpg
// module id = ZhNz
// module chunks = 0